import { NationalMenuTileData } from './types';

const desserts: Array<NationalMenuTileData> = [
  {
    id: 'dessert1',
    name: 'Cinnabon® Mini Rolls',
    mobileImageUrl: '/images/nationalMenu/desserts/National_Desserts_CinnabonMinis.jpg',
    desktopImageUrl: '/images/nationalMenu/desserts/National_Desserts_CinnabonMinis.jpg',
    productDescription: '10 mini cinnamon rolls, topped with signature cream cheese frosting, are the perfect way to end pizza night. Or you can eat \'em first. Don\'t worry, we won\'t tell.',
    priority: 0,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dessert2',
    name: 'Ultimate Chocolate Chip Cookie',
    mobileImageUrl: '/images/nationalMenu/desserts/National_Desserts_ChocChipCookie.jpg',
    desktopImageUrl: '/images/nationalMenu/desserts/National_Desserts_ChocChipCookie.jpg',
    productDescription: 'Pizza night just got a whole lot sweeter. Freshly baked and warm from the oven, our cookie is packed with semi-sweet chocolate chips that melt in your mouth.',
    priority: 1,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dessert3',
    name: 'Triple Chocolate Brownie',
    mobileImageUrl: '/images/nationalMenu/desserts/National_Desserts_Brownie.jpg',
    desktopImageUrl: '/images/nationalMenu/desserts/National_Desserts_Brownie.jpg',
    productDescription: 'Chocolate, chocolate, and more chocolate. Dig into this rich, decadent brownie made with semi-sweet chocolate chips, dark chocolate chips and cocoa. Did we mention there’s chocolate?',
    priority: 2,
    vegetarian: false,
    handleClick: () => {}
  },
  {
    id: 'dessert4',
    name: 'Cinnamon Sticks',
    mobileImageUrl: '/images/nationalMenu/desserts/National_Desserts_CinnamonSticks.jpg',
    desktopImageUrl: '/images/nationalMenu/desserts/National_Desserts_CinnamonSticks.jpg',
    productDescription: 'Our freshly-baked cinnamon sticks are a sweet finale to pizza night. Don\'t forget the icing dip for added deliciousness!',
    priority: 3,
    vegetarian: false,
    handleClick: () => {}
  }
];

export default desserts;
